import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import React, { ComponentProps, useEffect, useState, CSSProperties } from 'react';
import { useSelector } from 'react-redux';

import { StateType } from '#app/Store';

type Props = Omit<ComponentProps<typeof Button>, 'color'> & {
  small?: boolean;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
  outlined?: boolean;
  color?: string;
  style?: CSSProperties;
  label?: string;
};

const ButtonComponent: React.FC<Props> = ({
  small,
  className,
  loading,
  disabled,
  outlined,
  color,
  style,
  label,
  ...props
}) => {
  const classes = useStyles();
  const screenReducer = useSelector((state: StateType) => state.ScreenReducer);
  const [isTall, setIsTall] = useState(true);

  useEffect(() => {
    if (screenReducer.screen) {
      const isTallScreen = ['MD', 'LG', 'XL'].includes(screenReducer.screen);
      if (isTallScreen !== isTall) {
        setIsTall(isTallScreen);
      }
    }
  }, [screenReducer.screen]);

  const buttonColor = color || '#0484c7';

  const computedStyle: CSSProperties = {
    ...style,
    backgroundColor: outlined ? 'unset' : buttonColor,
    color: loading ? 'rgba(255,255,255,0)' : outlined ? buttonColor : '#FFFFFF',
    borderColor: buttonColor,
    ...(disabled && {
      backgroundColor: '#d3d3d3',
      color: '#888888',
      borderColor: '#d3d3d3',
    }),
  };

  return (
    <Button
      className={clsx(
        className,
        isTall ? (small ? classes.buttonSmall : classes.button) : small ? classes.buttonVerySmall : classes.buttonSmall,
      )}
      variant={outlined ? 'outlined' : 'contained'}
      disabled={disabled}
      style={computedStyle}
      {...props}
    >
      {label}
    </Button>
  );
};

const useStyles = makeStyles({
  button: {
    fontSize: '10px !important',
    opacity: 0.9,
  },
  buttonSmall: {
    fontSize: '10px !important',
    opacity: 0.9,
    transform: 'scale(0.8)',
  },
  buttonVerySmall: {
    fontSize: '10px !important',
    opacity: 0.9,
    transform: 'scale(0.6)',
  },
});

export default ButtonComponent;
